import { createRuntime } from './runtime.js';

// A self-contained classic build remains available for file:// distribution.
const AsteroUI = createRuntime();
export default AsteroUI;
